export const USER_CONFIG = {
  username: "Haridev P",
  handle: "haridevp",
  hostname: "astra-redteam",
  role: "Security Research Intern | Offensive Security Specialist",
  tagline: "Offensive Security & Red Teaming • Security Research Intern @ ASTRA Lab, IIT Madras",
  lab: "ASTRA Lab (CyStar), IIT Madras",
  email: "haridevpnarayananivas@gmail.com",
  github: "https://github.com/haridevp",
  linkedin: "https://linkedin.com/in/haridevp",
  googleDev: "https://g.dev/haridevp",
  instagram: "https://www.instagram.com/_.haridev__/",
  website: "https://haridevp.dev",
  thmUserPublicId: "3223438",
  thmProfile: "https://tryhackme.com/p/ArtemizZ"
};